module.exports = __webpack_public_path__ + "media/images/soar/Historico_de_encontros-e22495c72e9cb1233c1eaabcee09964a.gif";